import { render, staticRenderFns } from "./DasboardDetail.vue?vue&type=template&id=6c2564e4&scoped=true"
import script from "./DasboardDetail.vue?vue&type=script&lang=js"
export * from "./DasboardDetail.vue?vue&type=script&lang=js"
import style0 from "./DasboardDetail.vue?vue&type=style&index=0&id=6c2564e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2564e4",
  null
  
)

export default component.exports